<template>
  <div>
    <b-form>
      <b-form-group id="exampleInputGroup1" label="WP Admin URL" label-for="wp_adminurl">
        <b-form-input id="wp_adminurl" type="text" v-model="value.adminURL" required @input="updateData()">
        </b-form-input>
      </b-form-group>
      <b-form-group id="exampleInputGroup1" label="Admin Username" label-for="wp_admin_username">
        <b-form-input id="wp_admin_username" type="text" v-model="value.adminUsername" required @input="updateData()">
        </b-form-input>
      </b-form-group>
      <b-form-group id="exampleInputGroup1" label="Website URL" label-for="website_url">
        <b-form-input id="website_url" type="text" v-model="value.URL" required @input="updateData()">
        </b-form-input>
      </b-form-group>
    </b-form>
  </div>
</template>

<script>
export default {
  name: 'wpadmindetails',
  props: ['value'],
  methods: {
    updateData() {
      this.$emit('input', this.value);
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Common/WpAdminDetails.vue